import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bb136dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "home-title"
}

import { computed, inject, Ref } from 'vue';
import BlockContainer from './block-container.vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'home-banner',
  props: {
    title: {
        type: String,
        default: '',
    },
    banner: {
        type: String,
        default: '',
    },
    logo: {
        type: String,
        default: '',
    },
    titleColor: {
        type: String,
        default: '#145190',
    },
},
  setup(__props) {

const props = __props;



const themeConfig = inject<Ref<any>>('themeConfig');

const store = useStore();

const getStyle = computed(() => {
    return `
        --home-banner-title-color: ${props.titleColor};
    `;
});

// 首页导航Logo
const bandIndexLogo = computed(
    () => props.logo || store.state.brand?.publishBrand?.brandConfig?.indexNavLogoUrl,
);

const getBanner = computed(() => {
    return props.banner || themeConfig?.value?.bannerUrl;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockContainer, {
    class: "home-banner",
    align: "center",
    justify: "center",
    style: _normalizeStyle(`background-image: url(${_unref(getBanner)});${_unref(getStyle)}`)
  }, {
    default: _withCtx(() => [
      _createVNode(BlockContainer, {
        class: "home-banner-content",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "home-logo",
            src: _unref(bandIndexLogo)
          }, null, 8, _hoisted_1),
          (__props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})